<template>
  <div class="SearchFilters-segment">
    <div
      v-if="availableFilters.location"
      class="SearchFilter"
    >
      <div class="Filters-items Block card is-rounded has-border">
        <div class="SearchSuggestion Locations">
          <location-autosuggest-alg
            :radius="radius"
            is-search-filter
          />
        </div>
      </div>
    </div>

    <search-filter-child-simple
      v-if="availableFilters.ted"
      data-cy-id="search-filter-ted"
      :query-keys="{ values: 'best_apprenticeship_employers' }"
      :tags="filters.best_apprenticeship_employers"
      :fallback-count="1"
      title="Best Apprenticeship Employers"
    />

    <search-filter-child-simple
      v-if="availableFilters.jobType"
      data-cy-id="search-filter-job-type"
      :query-keys="{ values: 'programme' }"
      :tags="filters.jobTypes"
      :fallback-count="11"
      title="Job Type"
    />

    <search-filter-child-simple
      v-if="availableFilters.companyIndustry"
      :query-keys="{ values: 'discipline' }"
      :tags="filters.companyIndustries"
      :fallback-count="10"
      title="Industry"
    />

    <search-filter-child
      v-if="availableFilters.jobRole"
      data-cy-id="search-filter-job-role"
      :query-keys="{ parent: 'disciplines_parent', values: 'discipline' }"
      :tags="filters.jobRoles"
      :fallback-count="10"
      title="Job Role "
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import searchFiltersChild from './search-filter-child.vue';
import searchFilterChildSimple from './search-filter-child-simple.vue';
import LocationAutosuggestAlg from '@/components/form/location-autosuggest-alg';

export default {
  name: 'SearchFilters',

  components: {
    'search-filter-child': searchFiltersChild,
    'search-filter-child-simple': searchFilterChildSimple,
    LocationAutosuggestAlg,
  },

  props: {
    availableFilters: {
      type: Object,
      default: null,
    },
  },

  computed: {
    ...mapState('search', {
      filters: (state) => state.filters,
      type: (state) => state.query.show,
      location: (state) => state.query.location,
      radius: (state) => state.query.radius,
    }),
  },
};
</script>

<style lang="scss">

 @import "../../../../scss/abstracts/abstracts";

 .Locations .aa-Autocomplete .aa-InputWrapperPrefix .aa-LoadingIndicator {
   position: absolute !important;
 }

  .Filters-mobile {
    border-radius: 5px;
    height: 40px;
    display: block;
    line-height: 40px;
    margin: 0 1rem 1rem 1rem;
    color: color('white');

    .Button {
      border: 2px solid color($primary-color);
      box-shadow: none;
      background: transparent;
      color: color($primary-color);
      width: 100%;
    }
    @include respond-to(md, max-width) {
      background: #fff;
      height: auto;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      padding: .5rem calc(1rem + 1px);
      z-index: 3;
      margin: 0;
      border-radius: 0;
    }
    @include respond-to(md) {
      display: none;
    }
  }

  .MobileFilterApplyFilter {
    display: none;
  }

  .Filters {
    position: fixed;
    left: 0;
    background: #fff;
    text-align: center;
    display: none;
    bottom: 0;
    z-index: 99;
    color: color('white');
    border-radius: 5px;
    padding: .5rem;
    /*display:none;*/
  }

  .SearchFilters-count {
    color: color('grey');
    padding-left: 4px;
  }

  .Filters-overlay {
    display: block;
    background: rgba(0, 0, 0, 0.8);
    position: fixed;
    left: 0;
    right: 0;
    z-index: 7;
    width: 100%;
    height: 100%;
    top: 0;
    @include respond-to(md, max-width) {
      display: block;
    }
  }

  .MobileFilterApplyFilter {
    @include respond-to(md, max-width) {
      display: block;
      position: fixed;
      z-index: 9;
      left: 10px;
      right: 10px;
      bottom: 10px;
      max-width: 430px;
      width: auto;

      .Button {
        width: 100%;
      }
    }
  }

  .Filters-container {
    @include respond-to(md, max-width) {
      background: rgba(0, 0, 0, 0.8);
      position: fixed;
      overflow: hidden;
      opacity: 0;
      visibility: hidden;
      top: 0;
      left: 0;
      height: 100%;
      max-width: 450px;
      width: 100%;
      transition: .3s ease;
      z-index: 9;
      .SearchFilters-lists{
        padding-left: spacing();
        padding-right: spacing();
      }
      &.is-active {
        opacity: 1;
        visibility: visible;
        .MobileFilterApplyFilter,
        .SearchFilters-lists {
          transform: translateX(0);
        }
      }
    }
  }

  .SearchFilters-lists,
  .MobileFilterApplyFilter {
    @include respond-to(md, max-width) {
      background: #fff;
      transition: .3s ease;
      transform: translateX(-100%);
    }

  }

  .SearchFilters-lists {
    @include respond-to(md, max-width) {
      max-width: 450px;
      width: 100%;
      overflow: scroll;
      height: 100%;
      padding-bottom: 4.5rem;
    }
  }
  .field {
    margin-bottom: 0;
  }
</style>
